// extracted by mini-css-extract-plugin
module.exports = {"speakersItem":"SpeakersItem_speakersItem__3M6X9","speakersItemAvatar":"SpeakersItem_speakersItemAvatar__1oRVN","speakersItemContent":"SpeakersItem_speakersItemContent__2kL4l"};